import { render, staticRenderFns } from "./AubeCoinExBonusHistory.vue?vue&type=template&id=74fa88aa&scoped=true&"
import script from "./AubeCoinExBonusHistory.vue?vue&type=script&lang=js&"
export * from "./AubeCoinExBonusHistory.vue?vue&type=script&lang=js&"
import style0 from "./AubeCoinExBonusHistory.vue?vue&type=style&index=0&id=74fa88aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fa88aa",
  null
  
)

export default component.exports